export const producerConstants = {
  RESET: 'PRODUCER_RESET',
  INITIALIZE: 'PRODUCER_INITIALIZE',
  ON_AIR: 'PRODUCER_ON_AIR',
  ON_EVAL: 'PRODUCER_ON_EVAL',
  CANCEL_EVAL: 'PRODUCER_CANCEL_EVAL',
  OFF_EVAL: 'PRODUCER_OFF_EVAL',
  SET_END: 'PRODUCER_SET_END',
  EXPORT_DATA: 'PRODUCER_EXPORT_DATA',
  REQUEST_INQUIRY: 'PRODUCER_REQUEST_INQUIRY',
  RESOLVE_INQUIRY: 'PRODUCER_RESOLVE_INQUIRY',
  LIVE: 'PRODUCER_LIVE',
  CHANGE_ROUND: 'PRODUCER_CHANGE_ROUND',
  EDIT: 'PRODUCER_EDIT',
  JUDGE: 'PRODUCER_JUDGE',
  CLIP: 'PRODUCER_CLIP',
  UPDATE_LINEUP_SUCCESS: 'PRODUCER_UPDATE_LINEUP_SUCCESS',
  UPDATE_LINEUP_FAILURE: 'PRODUCER_UPDATE_LINEUP_FAILURE',
  SHOW_SCORES: 'PRODUCER_SHOW_SCORES',
  SORT_LINEUP: 'PRODUCER_SORT_LINEUP',
  SYNC_PRODUCER: 'PRODUCER_SYNC_PRODUCER',
  RESET_LINEUP: 'PRODUCER_RESET_LINEUP',
  FORCE: 'PRODUCER_FORCE',
  FORCE_SELECT: 'PRODUCER_FORCE_SELECT',
};

export const exportDataHeaders = [
  'Round',
  'Order',
  /*'ID',*/
  'Name',
  'Team',
  'Rotation',
  'Score',
  'Difficulty',
  'Execution',
  'Neutral Deduction',
  'Stick Bonus',
  'Inquiry',
  'Date',
  'Event',
  'Start Time',
  'End Time',
];

// Key used to identify in drag and drop, cannot change with data, could use athleteId, but that is not assigned in open session cases
export const emptyLineup = [
  {
    name: '',
    evaluation: null,
    score: null,
    order: 1,
    athleteId: null,
    key: null,
    startTime: null,
    endTime: null,
  },
  {
    name: '',
    evaluation: null,
    score: null,
    order: 2,
    athleteId: null,
    key: null,
    startTime: null,
    endTime: null,
  },
  {
    name: '',
    evaluation: null,
    score: null,
    order: 3,
    athleteId: null,
    key: null,
    startTime: null,
    endTime: null,
  },
  {
    name: '',
    evaluation: null,
    score: null,
    order: 4,
    athleteId: null,
    key: null,
    startTime: null,
    endTime: null,
  },
  {
    name: '',
    evaluation: null,
    score: null,
    order: 5,
    athleteId: null,
    key: null,
    startTime: null,
    endTime: null,
  },
  {
    name: '',
    evaluation: null,
    score: null,
    order: 6,
    athleteId: null,
    key: null,
    startTime: null,
    endTime: null,
  },
];

export const emptyTeam = {
  index: 0,
  home: false,
  onAir: false,
  onEval: false,
  lineup: null,
  score: '0.000',
  logo: null,
  name: null,
  color: '#00A2FF',
};

export const initialProducerState = {
  onAirAthlete: 1, // This goes from 1-n but competition order alternating
  onEvalAthletes: { A: null, B: null }, // This goes from 1-n
  doneEvalAthletes: { A: [], B: [] }, // Cumulative index gathering for completed evals
  exportData: null,
  teamA: Object.assign({}, emptyTeam),
  teamB: Object.assign({}, emptyTeam),
  round: 1,
  loaded: false,
  onAir: false,
  live: false,
  type: null,
  edit: false,
  clip: false,
  judge: false,
  scores: false,
  force: false,
  completedRounds: [],
};
